export default {
	lang: 'fr',
	nav: {
		"nav_lang_zh": '中文（简体）',
		"nav_lang_en": 'English',
		"nav_lang_tw": '中文（繁體）',
		"nav_lang_ja": '日本語',
		"nav_lang_ko": '한국어',
		"nav_lang_de": 'Deutsch',
		"nav_lang_fr": 'Français',
		"nav_lang_th": 'ภาษาไทย',
		"nav_lang_it": 'Italiano',
		"nav_lang_es": 'Español',
		"nav_lang_ru": 'Русский',
		"nav":"IA VORMOR",
		"nav2":"Sécurité du compte",
		"nav3":"Mon disque cloud",
		"nav4":"Se déconnecter",
		"nav5":"Se connecter",
		"nav6":"Espace nuageux",
		"nav7":"ChatGPT grand modèle",
		"nav8":"Système d'enregistrement vocal intelligent Cloud Space",
		"nav_phone_number_code":'Numéro de téléphone',
		"nav_update":'Changer',
		"nav_bind":'Lier',
		"nav_phone_code_tips":`Pour confirmer que c'est bien vous qui opérez, veuillez terminer la vérification d'identité via le code de vérification par téléphone`,
		"nav_phone_number":'Numéro de téléphone portable',
		"nav_phone_number_verify":'Changer la vérification du numéro de téléphone',
		"nav_phone_email_verify":'Basculer la vérification par e-mail',
		"nav_set_phone_number":'Définir un nouveau numéro de téléphone',
		"nav_verify_login":'Vérifier la connexion',
		"nav_phone_email":'Email/Téléphone',
		"nav_phone_login":'Connexion par vérification mobile',
		"nav_email_login":'Connexion par vérification email',
		"nav_email_fail":'Format d\'email incorrect, veuillez réessayer',
		"nav_pw_fail":'Le format du mot de passe est incorrect, veuillez le saisir à nouveau',
		"nav_code_fail":'Le code de vérification est incorrect',
		"nav_phone_fail":'Le format du numéro de téléphone est incorrect, veuillez le saisir à nouveau',
		"nav_input_fail":'Veuillez entrer une adresse e-mail',
		"nav_input_phone":'Veuillez entrer un numéro de téléphone',
		"nav_phone_verify_back":'Récupération par vérification du téléphone',
		"nav_email_verify_back": "Récupération par vérification d'e-mail"
	},
	login: {
		"login1":"Connexion par mot de passe",
		"login2":"Connexion par SMS",
		"loginTab3":"Connexion par e-mail",
		"login3":"Mail",
		"login4":"Mot de passe de connexion",
		"login5":"Numéro de téléphone",
		"login6":"Veuillez sélectionner",
		"login7":"Code de vérification mobile",
		"login8":"Se connecter",
		"login9":"oublier le mot de passe",
		"login10":"registre",
		"login11":"En vous connectant, vous acceptez",
		"login12":"Contrat de service",
		"login13":"politique de confidentialité",
		"login14":"Obtenir",
		"login15":"Chine",
		"login16":"Veuillez entrer votre numéro de compte",
		"login17":"Veuillez entrer votre mot de passe",
		"login18":"Connexion réussie !",
		"login19":"Veuillez entrer le code de vérification !",
		"login20":"Envoyé avec succès!",
		"login21":"et",
		"login22":"Disque cloud enregistreur vocal",
		"login23":"Mon écriture",
		"login24":"Ma conversation",
		"login25":"Sécurité du compte",
		"login26":"Se déconnecter",
		"login27":"Récupérer le mot de passe par e-mail",
		"login28":"Mail",
		"login29":"Code de vérification de l'e-mail",
		"login30":"Définir un mot de passe de connexion (6 à 16 caractères)",
		"login31":"Saisissez à nouveau votre mot de passe de connexion",
		"login32":"soumettre",
		"login33":"Retour à la connexion",
		"login34":"Modification réussie !",
	},
	register: {
		"register1":"Numéro de téléphone",
		"register2":"Veuillez entrer votre numéro de téléphone",
		"register3":"Veuillez sélectionner",
		"register4":"Code de vérification mobile",
		"register5":"Définir le mot de passe",
		"register6":"Veuillez saisir le code de vérification",
		"register7":"6 à 16 caractères",
		"register8":"Confirmation du mot de passe",
		"register9":"Mail",
		"register10":"Veuillez entrer votre adresse e-mail",
		"register11":"Code de vérification de l'e-mail",
		"register12":"Veuillez saisir le code de vérification",
		"register13":"J'ai lu et j'accepte",
		"register14":"Veuillez lire et cocher la case qui accepte l'accord",
		"register15":"Le format du numéro de téléphone est incorrect/le numéro de téléphone a été enregistré",
		"register16":"Erreur de code de vérification mobile",
		"register17":"Veuillez saisir votre adresse e-mail / Le format de l'adresse e-mail est incorrect",
		"register18":"Erreur de format de courrier électronique",
		"register19":"Erreur de code de vérification de l'e-mail",
		"register20":"Veuillez définir le mot de passe sur 6 à 16 caractères",
		"register21":"Erreur de format de mot de passe",
		"register22":"Les mots de passe saisis deux fois ne correspondent pas. Veuillez les saisir à nouveau.",
		"register23":"Veuillez entrer votre mot de passe",
		"register24":"Inscription réussie !",
		"register25":"Erreur de code de vérification",
	},
	recorder:{
		"recorder1":"Disque cloud d'enregistreur vocal",
		"recorder2":"Capacité de l'espace cloud",
		"recorder3":"document",
		"recorder331":"Corbeille",
		"recorder332":"Tout effacer",
		"recorder4":"nom",
		"recorder5":"Durée de l'audio",
		"recorder6":"Taille du fichier",
		"recorder7":"Temps de création",
		"recorder8":"fonctionner",
		"recorder9":"Description de l'espace nuageux",
		"recorder10":"document",
		"recorder11":"Fichier OCR",
		"recorder12": "1. Utilisation de l'espace Cloud",
		"recorder13": `après avoir enregistré des enregistrements, des notes manuscrites sur un livre de bureau intelligent, un stylo, vous pouvez passer sur le disque nuage, même si l'appareil intelligent n'est pas à proximité, vous pouvez entrer dans l'espace nuage pour afficher le fichier de notes. `,
		"recorder14": '2. Comment télécharger un espace Cloud? ',
		"recorder15": `stylo d'enregistrement: Allez dans l'appareil [mes fichiers] → cliquez sur actions par lots → cliquez sur" télécharger "pour ajouter le fichier à la file d'attente de téléchargement dans le cloud pour le télécharger dans l'espace Cloud. `,
		"recorder16": "Smart Office book",
		"recorder17": `méthode 1: appuyez longuement sur la liste des notes, sélectionnez par lots les notes à télécharger → cliquez sur" synchroniser "Pour terminer le téléchargement; `,
		"recorder171": `méthode deux: Ouvrez la page de détails d'une seule note → cliquez sur [plus - synchroniser] pour télécharger cette note dans l'espace Cloud. `,
		"recorder18":"Non transcrit",
		"recorder19":"Voir le résumé",
		"recorder20":"Conférencier",
		"recorder21":"Modifier le nom du locuteur",
		"recorder22":"Bien sûr",
		"recorder23":"télécharger",
		"recorder24":"Télécharger le contenu :",
		"recorder25":"Paramètres de téléchargement :",
		"recorder26":"Afficher le haut-parleur",
		"recorder27":"Annuler",
		"recorder28":"Partage de liens",
		"recorder29":"Toute personne recevant le lien peut y accéder. Ce lien est uniquement destiné à la lecture et valable 7 jours.",
		"recorder30":"Copier le lien",
		"recorder31":"Numérisez et visualisez rapidement",
		"recorder32":"Organisation intelligente",
		"recorder33":"Faire la différence entre les locuteurs",
		"recorder34":"Distinguer intelligemment le texte transcrit en fonction du rôle du locuteur",
		"recorder35":"Régularisation intelligente du langage parlé",
		"recorder36":"Filtrer automatiquement les particules modales, les mots répétés et les mots de pause",
		"recorder37":"Filtrage non vocal",
		"recorder38":"Ignorer automatiquement l'audio sans voix ni bruit pendant la lecture",
		"recorder39":"Veuillez sélectionner",
		"recorder40":"document",
		"recorder41":"Audio",
		"recorder42":"Documents + Audio",
		"recorder43":"indice",
		"recorder44":"Cette opération supprimera des fichiers, souhaitez-vous continuer ?",
		"recorder441":"Cette opération supprimera tous les fichiers, voulez-vous continuer ?",
		"recorder45":"Bien sûr",
		"recorder46":"Annuler",
		"recorder47":"Supprimé avec succès !",
		"recorder48":"Non supprimé",
		"recorder49":"Pas encore de tags",
		"recorder50":"Économie...",
		"recorder51":"Corbeille",
	},
	personal: {
		"personal1":"Paramètres du compte",
		"personal2":"informations personnelles",
		"personal3":"avatar",
		"personal4":"Télécharger des fichiers",
		"personal5":"Prise en charge des styles JPG, JPEG, GIF, PNG, prise en charge des images jusqu'à 2 M",
		"personal6":"Surnom",
		"personal7":"Veuillez entrer votre pseudo",
		"personal8":"genre",
		"personal9":"Messieurs",
		"personal10":"Manquer",
		"personal11":"Confidentialité",
		"personal12":"Anniversaire",
		"personal13":"Veuillez sélectionner votre date de naissance",
		"personal14":"Profession",
		"personal15":"Veuillez sélectionner votre profession",
		"personal16":"Veuillez indiquer votre profession (facultatif)",
		"personal17":"nation",
		"personal18":"Veuillez sélectionner votre pays",
		"personal19":"garder",
		"personal20":"informations personnelles",
		"personal21":"Sécurité du compte",
		"personal22":"Prend uniquement en charge les images jusqu'à 2 M",
		"personal23":"Téléchargement réussi !",
		"personal24":"Modification réussie !",
		"personal25":"Sécurité du compte",
		"personal26":"Mot de passe de connexion",
		"personal27":"Réviser",
		"personal28":"E-mail",
		"personal29":"remplacer",
		"personal30":"Annulation de compte",
		"personal32":"Êtes-vous sûr de vouloir annuler votre compte ?",
		"personal33":"Après vous être déconnecté, tout le contenu de votre compte sera effacé, veuillez donc procéder avec prudence.",
		"personal34":"Annuler",
		"personal35":"Bien sûr",
		"personal36":"Authentification",
		"personal37":"Pour confirmer que c'est bien vous qui faites cela, veuillez compléter la vérification d'identité via le code de vérification par e-mail",
		"personal38":"Mail",
		"personal39":"Le code de vérification",
		"personal40":"Veuillez saisir le code de vérification",
		"personal41":"Prochaine étape",
		"personal42":"Configurer une nouvelle boîte aux lettres",
		"personal43":"Mail",
		"personal44":"Veuillez saisir une nouvelle adresse e-mail",
		"personal45":"Le code de vérification",
		"personal46":"Veuillez saisir le code de vérification",
		"personal47":"Bien sûr",
		"personal48":"Définir un nouveau mot de passe de connexion",
		"personal49":"Nouveau mot de passe de connexion",
		"personal50":"Veuillez entrer un nouveau mot de passe",
		"personal51":"Confirmer le nouveau mot de passe",
		"personal52":"Veuillez saisir à nouveau votre nouveau mot de passe",
		"personal53":"Bien sûr",
		"personal54":"Obtenir",
		"personal55":"Erreur de format de courrier électronique",
		"personal56":"Remplacement réussi !",
		"personal57":"Veuillez définir le mot de passe sur 6 à 16 caractères",
		"personal58":"Les mots de passe que vous avez saisis deux fois ne correspondent pas",
		"personal59":"Modification réussie !",
		"personal60":"Déconnexion réussie !",
		
		"share_url": "Partage du lien",
		"share_url_7_day": "Le lien de partage est valable 7 jours. Avant son expiration, toute personne qui obtient le lien peut y accéder.",
		"share_audio": "Enregistrement audio",
		"share_trans_text": "Transcription",
		"share_summny_text": "Résumé",
		"share_map": "Carte heuristique",
		"share_url_pw": "Cryptage d'accès",
		"share_random_pw": "Mot de passe généré aléatoirement",
		"share_url_copy": "Copier le lien",
		"share_url_copy_success": "Copier le lien avec succès",
		"share_link_pw": "Mot de passe d'accès",
		"share_copy_success": "La transcription a été copiée dans le presse-papiers !",
		"share_copy_success2": "Le contenu du résumé a été copié dans la planche à découper!",
		"share_speaker": "Orateur",
		"share_no_update_speaker": "Impossible de modifier l'orateur vide",
		"share_no_trans":"Aucune transcription",
		"share_no_summny":"Non summary",
		"share_no_map": "Aucun contenu cartographique",
		"share_trans_text_1": "Transcription",
		"share_summny_text_1": "Résumé",
		"share_map_1": "Carte",
		"share_save": "Enregistrement réussi",
		"share_no_map": "Image cartographique non générée",
		"share_update_text": "Modifier le texte de la transcription",
		"share_update_text2": "Modifier le texte du résumé",
		"showLoading": "chargement...",
		"handwriting": "Contenu manuscrit",
		"handwritingText": "Écriture manuscrite",
		"share_1": "Le contenu manuscrit de cette page n'est pas reconnu",
		"share_2": "Modifier la reconnaissance de l'écriture manuscrite",
		"share_3": "Reconnaissance de l'écriture manuscrite",
		"share_4":"Exporter un fichier, ne quittez pas cette page",
		"folder_text":"Dossier",
		"folder_text_update_name":"Renommer",
		"folder_text_del":"Supprimer",
		"folder_text_all":"Tous",
		"folder_text_type":"Type de fichier",
		"folder_text_audio":"Notes audio",
		"folder_text_writing":"Notes manuscrites",
		"folder_text_file_type":"Type de fichier",
		"folder_text_add":"Créer un nouveau dossier",
		"folder_text_input_name":"Veuillez saisir un nom",
		"folder_text_cancel":"Annuler",
		"folder_text_summit":"Confirmer",
		"folder_text_name_not_null":"Le nom ne peut pas être vide",
		"folder_text_add_success":"Créé avec succès !",
		"folder_text_del_confirm":"Suppression confirmée",
		"folder_text_confirm":"Êtes-vous sûr de vouloir Supprimer le dossier sélectionné ? Les notes qu'il contient seront déplacées vers la corbeille après suppression.",
		"folder_text_del_success":"Suppression réussie !",
		"folder_text_move":"Déplacé vers",
		"folder_text_move_success":"Déplacé avec succès !",
		"folder_update_name":"Dossier renommé",
		"folder_text_update_success":"Modifié avec succès !",
		"empty_text":"Aucune donnée disponible.",
		"trans_text_null":"Le texte transcrit ne peut pas être vide",
		"summary_text_null":"Le résumé ne peut pas être vide",
		"please_create_folder":"Veuillez d'abord créer un dossier"
	}
}